const configs = {
    api_url: 'https://timeshare-exchange-platform-be.onrender.com/api/v2',
};

export default configs;
// http://localhost:8080/api/v2
// https://nice-trip.onrender.com/api/v2
